<script>
export let classes = "";
export let classes_content = "";
export let classes_container = "";
export let style_checkbox_content = "width:100%;";
export let style_checkbox_container = "";
export let styles_container = "";
export let has_circle = false;
export let is_column = false;
export let showChecBox = false;

</script>
<checkbox-radio role="checkbox" class="input-radio {classes} {showChecBox ? "has-visible-check-box" : ""}" aria-checked="false" style="{styles_container}">
    <!-- svelte-ignore a11y-label-has-associated-control -->
    <label style="margin-bottom: 0px !important;">
        <slot></slot>
        <checkradio-container class="{classes_container} {is_column ? "is-flex-direction-column-reverse": ""}" style="{style_checkbox_container}">
            {#if has_circle}
                <checkbox-circle class="input-circle flex-center">
                    <div class="inner-circle"></div>
                </checkbox-circle>
            {/if}
            <checkbox-content class="{classes_content}" style="{style_checkbox_content}">
                <slot name="content"></slot>
            </checkbox-content>
        </checkradio-container>
    </label>
</checkbox-radio>
<style>
checkbox-radio.has-visible-check-box:global( label input[type=checkbox]){
    opacity: 1 !important;
    top: 10px;
    left: 10px;
    height: 16px;
    width: 16px;
}
checkbox-content.post-editor-restricted{
    width: 100%;
    height: 100%;
    overflow: hidden;
}
checkbox-content.post-editor-restricted:global( figure){
    width: 100%;
    height: 100%;
}
checkbox-content.post-editor-restricted:global( img){
    width: 100%;
    object-fit: cover;
}
</style>